export default {
    TOGGLE_MENU: 'TOGGLE_MENU'
}